import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { toRef } from 'vue';
import { useStore } from 'vuex';
import ErrorSummary from '@src/components/shared/ErrorSummary.vue';
import { AddressTypeModel } from '@src/view_models/AddressTypeModel';
import type { ReturnType as ReceiptModel } from '@src/components/shared/composables/useReceiptModel';

interface Props {
	showErrorSummary: boolean;
	addressType: AddressTypeModel;
	receiptModel: ReceiptModel;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorSummary',
  props: {
    showErrorSummary: { type: Boolean },
    addressType: {},
    receiptModel: {}
  },
  setup(__props: any) {


const props = __props;
const store = useStore();
const receiptModel = toRef<ReceiptModel>( props.receiptModel );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!receiptModel.value.receiptNeeded && __props.addressType === _unref(AddressTypeModel).UNSET)
      ? (_openBlock(), _createBlock(ErrorSummary, {
          key: 0,
          "is-visible": __props.showErrorSummary,
          items: [
			{
				validity: _unref(store).state.payment.validity.amount,
				message: _ctx.$t( 'error_summary_amount' ),
				focusElement: 'amount-500',
				scrollElement: 'payment-form-amount',
			},
			{
				validity: _unref(store).state.payment.validity.type,
				message: _ctx.$t( 'error_summary_payment_type' ),
				focusElement: 'paymentType-0',
				scrollElement: 'payment-form-type',
			},
			{
				validity: _unref(store).state.bankdata.validity.iban,
				message: _ctx.$t( 'donation_form_payment_iban_error' ),
				focusElement: 'iban',
				scrollElement: 'payment-form-iban-calculator',
			},
			{
				validity: _unref(store).state.address.validity.salutation,
				message: _ctx.$t( 'donation_form_salutation_error' ),
				focusElement: 'salutation-0',
				scrollElement: 'address-form-salutation',
			},
			{
				validity: _unref(store).state.address.validity.firstName,
				message: _ctx.$t( 'donation_form_firstname_error' ),
				focusElement: 'first-name',
				scrollElement: 'address-form-first-name',
			},
			{
				validity: _unref(store).state.address.validity.lastName,
				message: _ctx.$t( 'donation_form_lastname_error' ),
				focusElement: 'last-name',
				scrollElement: 'address-form-last-name',
			},
			{
				validity: _unref(store).state.address.validity.email,
				message: _ctx.$t( 'donation_form_email_error' ),
				focusElement: 'email',
				scrollElement: 'address-form-email',
			},
		]
        }, null, 8, ["is-visible", "items"]))
      : _createCommentVNode("", true),
    (( receiptModel.value.receiptNeeded && __props.addressType === _unref(AddressTypeModel).UNSET ) || __props.addressType === _unref(AddressTypeModel).PERSON)
      ? (_openBlock(), _createBlock(ErrorSummary, {
          key: 1,
          "is-visible": __props.showErrorSummary,
          items: [
			{
				validity: _unref(store).state.payment.validity.amount,
				message: _ctx.$t( 'error_summary_amount' ),
				focusElement: 'amount-500',
				scrollElement: 'payment-form-amount',
			},
			{
				validity: _unref(store).state.payment.validity.type,
				message: _ctx.$t( 'error_summary_payment_type' ),
				focusElement: 'paymentType-0',
				scrollElement: 'payment-form-type',
			},
			{
				validity: _unref(store).state.bankdata.validity.iban,
				message: _ctx.$t( 'donation_form_payment_iban_error' ),
				focusElement: 'iban',
				scrollElement: 'payment-form-iban-calculator',
			},
			{
				validity: _unref(store).state.address.validity.salutation,
				message: _ctx.$t( 'donation_form_salutation_error' ),
				focusElement: 'salutation-0',
				scrollElement: 'address-form-salutation',
			},
			{
				validity: _unref(store).state.address.validity.firstName,
				message: _ctx.$t( 'donation_form_firstname_error' ),
				focusElement: 'first-name',
				scrollElement: 'address-form-first-name',
			},
			{
				validity: _unref(store).state.address.validity.lastName,
				message: _ctx.$t( 'donation_form_lastname_error' ),
				focusElement: 'last-name',
				scrollElement: 'address-form-last-name',
			},
			{
				validity: _unref(store).state.address.validity.email,
				message: _ctx.$t( 'donation_form_email_error' ),
				focusElement: 'email',
				scrollElement: 'address-form-email',
			},
			{
				validity: _unref(store).state.address.validity.country,
				message: _ctx.$t( 'donation_form_country_error' ),
				focusElement: 'country',
				scrollElement: 'address-form-country',
			},
			{
				validity: _unref(store).state.address.validity.postcode,
				message: _ctx.$t( 'donation_form_zip_error' ),
				focusElement: 'post-code',
				scrollElement: 'address-form-post-code',
			},
			{
				validity: _unref(store).state.address.validity.city,
				message: _ctx.$t( 'donation_form_city_error' ),
				focusElement: 'city',
				scrollElement: 'address-form-city',
			},
			{
				validity: _unref(store).state.address.validity.street,
				message: _ctx.$t( 'donation_form_street_error' ),
				focusElement: 'street',
				scrollElement: 'address-form-street',
			},
		]
        }, null, 8, ["is-visible", "items"]))
      : _createCommentVNode("", true),
    (__props.addressType === _unref(AddressTypeModel).COMPANY_WITH_CONTACT)
      ? (_openBlock(), _createBlock(ErrorSummary, {
          key: 2,
          "is-visible": __props.showErrorSummary,
          items: [
			{
				validity: _unref(store).state.payment.validity.amount,
				message: _ctx.$t( 'error_summary_amount' ),
				focusElement: 'amount-500',
				scrollElement: 'payment-form-amount',
			},
			{
				validity: _unref(store).state.payment.validity.type,
				message: _ctx.$t( 'error_summary_payment_type' ),
				focusElement: 'paymentType-0',
				scrollElement: 'payment-form-type',
			},
			{
				validity: _unref(store).state.bankdata.validity.iban,
				message: _ctx.$t( 'donation_form_payment_iban_error' ),
				focusElement: 'iban',
				scrollElement: 'payment-form-iban-calculator',
			},
			{
				validity: _unref(store).state.address.validity.salutation,
				message: _ctx.$t( 'donation_form_salutation_error' ),
				focusElement: 'salutation-0',
				scrollElement: 'address-form-salutation',
			},
			{
				validity: _unref(store).state.address.validity.firstName,
				message: _ctx.$t( 'donation_form_firstname_error' ),
				focusElement: 'first-name',
				scrollElement: 'address-form-first-name',
			},
			{
				validity: _unref(store).state.address.validity.lastName,
				message: _ctx.$t( 'donation_form_lastname_error' ),
				focusElement: 'last-name',
				scrollElement: 'address-form-last-name',
			},
			{
				validity: _unref(store).state.address.validity.email,
				message: _ctx.$t( 'donation_form_email_error' ),
				focusElement: 'email',
				scrollElement: 'address-form-email',
			},
			{
				validity: _unref(store).state.address.validity.companyName,
				message: _ctx.$t( 'donation_form_companyname_error' ),
				focusElement: 'company-name',
				scrollElement: 'address-form-company-name',
			},
			{
				validity: _unref(store).state.address.validity.country,
				message: _ctx.$t( 'donation_form_country_error' ),
				focusElement: 'country',
				scrollElement: 'address-form-country',
			},
			{
				validity: _unref(store).state.address.validity.postcode,
				message: _ctx.$t( 'donation_form_zip_error' ),
				focusElement: 'post-code',
				scrollElement: 'address-form-post-code',
			},
			{
				validity: _unref(store).state.address.validity.city,
				message: _ctx.$t( 'donation_form_city_error' ),
				focusElement: 'city',
				scrollElement: 'address-form-city',
			},
			{
				validity: _unref(store).state.address.validity.street,
				message: _ctx.$t( 'donation_form_street_error' ),
				focusElement: 'street',
				scrollElement: 'address-form-street',
			},
		]
        }, null, 8, ["is-visible", "items"]))
      : _createCommentVNode("", true),
    (__props.addressType === _unref(AddressTypeModel).EMAIL)
      ? (_openBlock(), _createBlock(ErrorSummary, {
          key: 3,
          "is-visible": __props.showErrorSummary,
          items: [
			{
				validity: _unref(store).state.payment.validity.amount,
				message: _ctx.$t( 'error_summary_amount' ),
				focusElement: 'amount-500',
				scrollElement: 'payment-form-amount',
			},
			{
				validity: _unref(store).state.payment.validity.type,
				message: _ctx.$t( 'error_summary_payment_type' ),
				focusElement: 'paymentType-0',
				scrollElement: 'payment-form-type',
			},
			{
				validity: _unref(store).state.bankdata.validity.iban,
				message: _ctx.$t( 'donation_form_payment_iban_error' ),
				focusElement: 'iban',
				scrollElement: 'payment-form-iban-calculator',
			},
			{
				validity: _unref(store).state.address.validity.salutation,
				message: _ctx.$t( 'donation_form_salutation_error' ),
				focusElement: 'salutation-0',
				scrollElement: 'address-form-salutation',
			},
			{
				validity: _unref(store).state.address.validity.firstName,
				message: _ctx.$t( 'donation_form_firstname_error' ),
				focusElement: 'first-name',
				scrollElement: 'address-form-first-name',
			},
			{
				validity: _unref(store).state.address.validity.lastName,
				message: _ctx.$t( 'donation_form_lastname_error' ),
				focusElement: 'last-name',
				scrollElement: 'address-form-last-name',
			},
			{
				validity: _unref(store).state.address.validity.email,
				message: _ctx.$t( 'donation_form_email_error' ),
				focusElement: 'email',
				scrollElement: 'address-form-email',
			},
		]
        }, null, 8, ["is-visible", "items"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})